import { render, staticRenderFns } from "./indexpublic.vue?vue&type=template&id=8a570d40&"
import script from "./indexpublic.vue?vue&type=script&lang=js&"
export * from "./indexpublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports